import { UserInterface, UserRolesEnum } from '../../interfaces/user.interface';
import { ErrorInterface } from '../../interfaces/general.interface';

export interface AuthCookieInterface extends AuthAdminEntityInterface {
  role: UserRolesEnum;
}

export interface AuthAdminEntityInterface {
  role: UserRolesEnum;
  id: string;
  ttl: number;
  type: string;
  refreshToken: string;
  createdAt: number;
  userID: number;
  user: UserInterface;
}

export interface AuthAdminState {
  entity: AuthAdminEntityInterface | null;
  error: boolean | ErrorInterface;
  loading: boolean;
}

export const initialAuthAdminState: AuthAdminState = {
  entity: null,
  error: false,
  loading: true,
};
